import { useNavigate, useLocation } from 'react-router'

export default function Menu() {
    const navigate = useNavigate()
    const location = useLocation()
    
    return (
        <div className="nav-container">
            <ul className="nav">
                <li className={`nav__item ${(location.pathname === '' || location.pathname === '/') ? `active`: ''}`} onClick={() => navigate('/')}>About</li>
                <li className={`nav__item ${(location.pathname === '/resume') ? `active`: ''}`} onClick={ () => navigate('/resume')}>Resume</li>
                <li className={`nav__item ${(location.pathname === '/portfolio') ? `active`: ''}`} onClick={ () => navigate('/portfolio')}>Portfolio</li>
                <li className={`nav__item ${(location.pathname === '/contact') ? `active`: ''}`} onClick={ () => navigate('/contact')}>Contact</li>
            </ul>
        </div>
    )
}